var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ButtonTemplate',{attrs:{"on-click":_vm.onClick,"icon":"question-square","title":"Insert User Details Question"}}),(_vm.showDialog)?_c('EditUserDetailsQuestionDialog',{on:{"ok":_vm.setQuestion},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }